<div
  class="header-container"
  data-cy="header-container"
>
  <div class="header-layout">
    <svg-icon class="mobile-menu-burger" (click)="openMobileMenu()" src="assets/icons/burger.svg" [svgStyle]="{ 'width.px':24 }" data-cy="mobile-menu-burger"></svg-icon>

    <a
      class="logo-container"
      (click)="navigate('workplace-summary')"
      (keydown.space)="navigate('workplace-summary')"
      (keydown.enter)="navigate('workplace-summary')"
      tabindex="0"
    >
      <svg-icon class="mobile-small" src="assets/logo/workplace-logo-small.svg" [svgStyle]="{ 'height.px':24, 'width.px':150 }"></svg-icon>
      <svg-icon class="mobile" src="assets/logo/workplace-logo-small.svg" [svgStyle]="{ 'height.px':32, 'width.px':200 }"></svg-icon>
      <svg-icon class="desktop" src="assets/logo/workplace-logo-big.svg" [svgStyle]="{ 'height.px':50, 'width.px':311 }"></svg-icon>
    </a>
    <div class="workplace-menu-items">
      <div
        class="workplace-menu-item workplace-menu-item--desktop"
        (click)="navigate('workplace-summary')"
        (keydown.space)="navigate('workplace-summary')"
        (keydown.enter)="navigate('workplace-summary')"
        tabindex="0"
      >
        {{ 'menu.myProfile' | translate }}
      </div>
      <div
        class="workplace-menu-item workplace-menu-item--desktop"
        data-cy="workplace-top-menu-my-clients"
        (click)="navigate('workplace-clients')"
        (keydown.space)="navigate('workplace-clients')"
        (keydown.enter)="navigate('workplace-clients')"
        tabindex="0"
      >
        {{ 'menu.myClients' | translate }}
      </div>
      <div
        class="workplace-menu-item workplace-menu-item--desktop"
        data-cy="workplace-top-menu-draft-templates"
        (click)="navigate(DRAFT_TEMPLATES_ROUTE)"
        (keydown.space)="navigate(DRAFT_TEMPLATES_ROUTE)"
        (keydown.enter)="navigate(DRAFT_TEMPLATES_ROUTE)"
        tabindex="0"
      >
        {{ 'menu.myDraftTemplates' | translate }}
      </div>
      <div
        class="workplace-menu-item workplace-menu-item--desktop workplace-menu-item--has-dropdown"
        data-cy="workplace-top-menu-new-draft"
        (click)="toggleDraftsDropdown($event)"
        (keydown.space)="toggleDraftsDropdown($event)"
        (keydown.enter)="toggleDraftsDropdown($event)"
        tabindex="0"
      >
        {{ 'menu.newDraft' | translate }}
        <svg-icon src="assets/icons/chevron-down-white.svg" [svgStyle]="{ 'width.px': 14, 'transform': draftsDropdownOpen() ? 'rotate(180deg)' : '' }"></svg-icon>
        @if (draftsDropdownOpen()) {
          <div class="drafts-dropdown">
            <div
              class="drafts-dropdown-item"
              (click)="navigate('newDraft', $event)"
              (keydown.space)="navigate('newDraft', $event)"
              (keydown.enter)="navigate('newDraft', $event)"
              tabindex="0"
            >
              {{ 'menu.draftsNewDraft' | translate }}
            </div>
            <div
              class="drafts-dropdown-item"
              (click)="navigate('sent-investment-drafts', $event)"
              (keydown.space)="navigate('sent-investment-drafts', $event)"
              (keydown.enter)="navigate('sent-investment-drafts', $event)"
              tabindex="0"
            >
              {{ 'menu.sentDrafts' | translate }}
            </div>
          </div>
        }
      </div>
      <div
        class="workplace-menu-item"
        data-cy="workplace-logout"
        (click)="logoutConsult()"
        (keydown.space)="logoutConsult()"
        (keydown.enter)="logoutConsult()"
        tabindex="0"
      >
        <div class="mobile-content">
          <svg-icon src="assets/icons/sign-out.svg" [svgStyle]="{ 'width.px':30 }"></svg-icon>
        </div>
        <div class="desktop-content">{{ 'menu.logoutWorkplace' | translate }}</div>
      </div>
    </div>
  </div>
</div>

@if (mobileMenuVisible) {
  <div class="mobile-menu-container">
    <div class="mobile-menu-header">
      <svg-icon src="assets/logo/workplace-logo-small.svg" [svgStyle]="{ 'height.px':32, 'width.px':200 }" (click)="closeMobileMenu()"></svg-icon>
      <div
        class="mobile-menu-close-button"
        (click)="closeMobileMenu()"
        (keydown.space)="closeMobileMenu()"
        (keydown.enter)="closeMobileMenu()"
        tabindex="0"
      >
        <svg-icon src="assets/icons/cross.svg" [svgStyle]="{ 'width.px':15 }"></svg-icon>
      </div>
    </div>
    <div class="mobile-menu-items">
      <div
        class="mobile-menu-item"
        (click)="closeMobileMenu('/workplace-summary')"
        (keydown.space)="closeMobileMenu('/workplace-summary')"
        (keydown.enter)="closeMobileMenu('/workplace-summary')"
        tabindex="0"
      >
        <svg-icon src="assets/icons/user-workplace.svg" [svgStyle]="{ 'width.px':15 }"></svg-icon>
        <p>{{ 'menu.myProfile' | translate }}</p>
      </div>
      <div
        class="mobile-menu-item"
        (click)="closeMobileMenu('/workplace-clients')"
        (keydown.space)="closeMobileMenu('/workplace-clients')"
        (keydown.enter)="closeMobileMenu('/workplace-clients')"
        tabindex="0"
        >
        <svg-icon src="assets/icons/workplace-clients.svg" [svgStyle]="{ 'width.px':25 }"></svg-icon>
        <p>{{ 'menu.myClients' | translate }}</p>
      </div>
      <div
        class="mobile-menu-item"
        (click)="closeMobileMenu('/' + DRAFT_TEMPLATES_ROUTE)"
        (keydown.space)="closeMobileMenu('/' + DRAFT_TEMPLATES_ROUTE)"
        (keydown.enter)="closeMobileMenu('/' + DRAFT_TEMPLATES_ROUTE)"
        tabindex="0"
        >
        <svg-icon src="assets/icons/file-description.svg" [svgStyle]="{ 'width.px':20 }"></svg-icon>
        <p>{{ 'menu.myDraftTemplates' | translate }}</p>
      </div>
      <div
        class="mobile-menu-item mobile-menu-item--has-sub"
        (click)="toggleMobileDrafts()"
        (keydown.space)="toggleMobileDrafts()"
        (keydown.enter)="toggleMobileDrafts()"
        tabindex="0"
      >
        <svg-icon src="assets/icons/workplace-draft.svg" [svgStyle]="{ 'width.px':25 }"></svg-icon>
        <p>{{ 'menu.newDraft' | translate }}</p>
        <svg-icon src="assets/icons/chevron-down-white.svg" [svgStyle]="{ 'width.px': 14, 'transform': mobileDraftsOpen() ? 'rotate(180deg)' : '' }"></svg-icon>
      </div>
      @if (mobileDraftsOpen()) {
        <div
          class="mobile-menu-item mobile-menu-item--sub"
          (click)="navigate('newDraft')"
          (keydown.space)="navigate('newDraft')"
          (keydown.enter)="navigate('newDraft')"
          tabindex="0"
        >
          <p>{{ 'menu.draftsNewDraft' | translate }}</p>
        </div>
        <div
          class="mobile-menu-item mobile-menu-item--sub"
          (click)="navigate('sent-investment-drafts', $event)"
          (keydown.space)="navigate('sent-investment-drafts', $event)"
          (keydown.enter)="navigate('sent-investment-drafts', $event)"
          tabindex="0"
        >
          <p>{{ 'menu.sentDrafts' | translate }}</p>
        </div>
      }
      <div
        class="mobile-menu-item mobile-menu-item--small"
        (click)="logoutConsult()"
        (keydown.space)="logoutConsult()"
        (keydown.enter)="logoutConsult()"
        tabindex="0"
      >
        {{ 'menu.logout' | translate }}
      </div>
    </div>
  </div>
}
